// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-check input {
  height: 24px;
  width: 24px;
  margin-right: 12px !important;
}

.form-check {
  display: flex !important;
  align-items: center;
  padding-top: 0px;
}

.form-check label {
  font-size: 14px !important;
  padding-top: 4px !important;
  color: #5a6a85 !important;
  font-weight: 400;
}

.filters-icon {
  height: 48px;
  padding: 9.99px;
  justify-content: flex-start;
  align-items: center;
  gap: 10.99px;
  display: inline-flex;
  background-color: white;
}

.fix-filter-icon-height {
  height: 42px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Classroom/Filters.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,6BAAA;AACF;;AAEA;EACE,wBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,0BAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,YAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF","sourcesContent":[".form-check input {\n  height: 24px;\n  width: 24px;\n  margin-right: 12px !important;\n}\n\n.form-check {\n  display: flex !important;\n  align-items: center;\n  padding-top: 0px;\n}\n\n.form-check label {\n  font-size: 14px !important;\n  padding-top: 4px !important;\n  color: #5a6a85 !important;\n  font-weight: 400;\n}\n\n.filters-icon {\n  height: 48px;\n  padding: 9.99px;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10.99px;\n  display: inline-flex;\n  background-color: white;\n}\n\n.fix-filter-icon-height {\n  height: 42px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
